// PDF-local design tokens. Mirrors `Murphy_Report_Design_Spec.md` sections 4-6
// (docs/murphy-report/Murphy_Report_Design_Spec.md). Keep this file in lockstep
// with the spec — the colors are identical to the app's web theme.js but live
// here so the PDF code has no dependency on app styles.

export const colors = {
  teal:       '#0784a7',
  tealDark:   '#055f7a',
  tealPale:   '#e6f3f7',
  bannerDark: '#15303d',

  success:    '#10b981',
  successBg:  '#e9f8f2',
  warning:    '#f59e0b',
  warningBg:  '#fdf3e0',
  danger:     '#ef4444',
  dangerBg:   '#fdecec',

  ink:        '#1e272e',
  inkSoft:    '#4a5560',
  muted:      '#7a8590',
  hair:       '#e6e9ec',
  cardBg:     '#f6f8fa',
};

const T = (weight, size, leading, extra = {}) => ({
  fontFamily: 'Montserrat',
  fontWeight: weight,
  fontSize: size,
  lineHeight: leading / size,
  ...extra,
});

export const type = {
  status:    T(700, 17, 22),
  h1:        T(700, 19, 23),
  cardTitle: T(600, 11, 14),
  body:      T(400, 9.5, 13.5),
  bodyMed:   T(500, 9.5, 13.5),
  caption:   T(400, 9,   12.5),
  micro:     T(400, 8.5, 12),
  eyebrow:   T(700, 7.5, 10, { letterSpacing: 0.9, textTransform: 'uppercase' }),
  chip:      T(600, 7.5, 10, { letterSpacing: 0.4 }),
};

export const page = {
  width: 612,
  height: 792,
  margin: 39.6,
  contentWidth: 532.8,
};

export const space = {
  xs: 4, sm: 8, md: 12, lg: 14, xl: 18, xxl: 22, xxxl: 28, huge: 38,
};

// Status → color triple mapping (used by banner, status block, summary card)
export const statusPalette = {
  green:  { fg: colors.success, bg: colors.successBg, bar: colors.success },
  amber:  { fg: colors.warning, bg: colors.warningBg, bar: colors.warning },
  red:    { fg: colors.danger,  bg: colors.dangerBg,  bar: colors.danger  },
  gray:   { fg: colors.inkSoft, bg: colors.hair,      bar: colors.muted   },
};
